export enum OrganizationType {
  // ИП
  Individual = 1,
  // ООО
  LLC = 2,
}
